import TextInput from "../../../sharedComponents/inputs/textInput";
import Lang from "../../../../userPreferences/staticWords";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../../../auth/formikValidation";
import DropDownList from "../../../sharedComponents/dropdown/dropdown";
import DateInput from "../../../sharedComponents/datesInputs/date";
import {
  addUserData,
  updateUser,
} from "../../../../API/store/actions/admin/userAction";
import Button from "../../../sharedComponents/buttons/button";
import { customStyle, styleStart } from "../../../../algorithms/styleDirection";
import { MemberListItem } from "./../../../../algorithms/listsAlogrithms";
import Switch from "./../../../sharedComponents/switch/switch";
import { useDispatch } from "react-redux";
import FileInput from "../../../sharedComponents/inputs/fileInput";
import { englishDate, objToFormData } from "../../../../algorithms";
import { paths } from "../../../../paths/paths";
import { useState } from "react";
import moment from "moment";
import FileUploader from "../../../reusableComponents/fileUploader";
import FilesList from "../../../reusableComponents/filesList";
const AddUserForm = ({
  userToken,
  isEdit,
  modalVisible,
  setModalVisible,
  data,
  dropdownLists,
  fromCommunity,
  usersDropdownLists,
  onSuccess,
}) => {
  const [disable, setDisable] = useState(false);
  const [files, setFiles] = useState([]);
  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const dispatch = useDispatch();
  const submit = async (data) => {
    let formData = new FormData();
    const newData = {
      firstNameA: data.firstName,
      firstNameE: data.firstName,
      lastNameA: data.lastName ?? "",
      lastNameE: data.lastName ?? "",
      mobileNumber: data.mobileNumber,
      email: data.email,
      UserName: data.UserName,
      // birthDate: data.brithDay,
      titleId: data.title,
      nationalityId: data.nationality,
      genderId: data.gender,
      professionalStatusId: data.professionalStatus,
      password: data.password,
      // researchAreaIDs: data.researchAreas,
      // isMember: data.isMember,
      ParentId: data.ParentId,
      PersonInContactId: data.PersonInContactId,
      Address: data.Address,
      OfficeNumber: data.OfficeNumber,
      activeMember: data.activeMember,
      active: data.active,
      PhotoFile: data?.PhotoFile,
      files: values.files,
      // isAdmin: data?.isAdmin,
      // isSuperAdmin: data?.isSuperAdmin,
      // isTaskAdmin: data?.isTaskAdmin,
    };
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    for (let [key, value] of Object.entries(newData)) {
      if (key == "files") {
        value.forEach((element) => {
          formData.append("files", element.file);
        });
      } else {
        formData.append(key, value);
      }
    }
    let res = await addUserData(
      formData,
      data?.IsAdmin,
      data?.IsSuperAdmin,
      data?.IsMember,
      data?.IsTaskAdmin,
      userToken,
    );
    onSuccess?.();
    if (res.status <= 206) {
      dispatch({ type: "RELOAD" });
      fromCommunity
        ? setModalVisible(false)
        : setModalVisible({
            ...modalVisible,
            ediUser: false,
            helperData: null,
            addUserData: false,
          });
      setDisable(false);
    } else {
      setDisable(false);
    }
  };
  const editSubmit = async (data) => {
    const newData = {
      UserId: modalVisible?.helperData?.id,
      FirstNameA: data.firstName,
      FirstNameE: data.firstName,
      LastNameA: data.lastName ?? "",
      LastNameE: data.lastName ?? "",
      MobileNumber: data.mobileNumber,
      Email: data.email,
      // birthDate: data?.brithDay,
      Password: data.password,
      TitleId: data.title,
      ProfessionalStatusId: data.professionalStatus,
      NationalityId: data.nationality,
      GenderId: data.gender,
      MemberActive: data.activeMember,
      Active: data.active,
      PhotoFile: data?.PhotoFile,
      UserName: data?.UserName,
      ParentId: data.ParentId,
      PersonInContactId: data.PersonInContactId,
      Address: data.Address,
      OfficeNumber: data.OfficeNumber,
    };

    if (!data.password) delete newData.password;

    let res = await updateUser(
      objToFormData(newData),
      data?.IsAdmin,
      data?.IsSuperAdmin,
      data?.IsMember,
      data?.IsTaskAdmin,
      userToken,
    );
    onSuccess?.();
    if (res.status <= 206) {
      dispatch({ type: "RELOAD" });
      // alert(JSON.stringify(values));
      fromCommunity
        ? setModalVisible(false)
        : setModalVisible({
            ...modalVisible,
            ediUser: false,
            helperData: null,
            addUserData: false,
          });
    }
  };
  const formik = useFormik(
    formikSetup(
      initialValues,
      isEdit ? data : {},
      validationSchema,
      "addUser",
      isEdit ? editSubmit : submit,
    ),
  );
  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    setFieldTouched,
    values,
  } = formik;

  if (Lang.getLanguage() === "ar") moment.locale("ar");
  else moment.locale("en");
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-wrap justify-content-center align-content-center mb-3 h-100">
          <div className="col-12 mx-3  d-flex justify-content-center align-items-end">
            {/* <FileInput
              iconPrefix={"far"}
              iconName={"user-circle"}
              iconColor={"white"}
              name={"user-circle"}
              fileName={" "}
              source={
                values.Logo
                  ? `${paths.CommunityLogo}${modalVisible?.helperData?.id}/${values.Logo}`
                  : ""
              }
              src={values.LogoFile}
              backgroundSize={95}
              backgroundColor={"#60606085"}
              size={95}
              uploaded={values.LogoFile ? true : false}
              uploadedMessage={values.LogoFile ? "تغيير" : ""}
              onChange={(e) => {
                setFieldValue("LogoFile", e.target.files[0]);
              }}
              error={formikValidation(touched, errors, "LogoFile")}
            /> */}
            <FileInput
              iconPrefix={"far"}
              iconName={"user-circle"}
              name={"user-circle"}
              fileName={" "}
              // src={values.PhotoFile}
              source={
                values.PhotoFile
                  ? `${paths.MemberPhoto}${data?.memberId}/${values.PhotoFile}`
                  : ""
              }
              backgroundSize={95}
              backgroundColor={"#60606085"}
              iconColor={" "}
              size={95}
              uploaded={values.PhotoFile ? true : false}
              uploadedMessage={values.PhotoFile ? "تغيير" : ""}
              onChange={(e) => {
                setFieldValue("PhotoFile", e.target.files[0]);
              }}
              error={formikValidation(touched, errors, "PhotoFile")}
            />
          </div>

          <div className="col-lg-11 col-12 px-3 mt-4">
            <TextInput
              type={"text"}
              value={values.firstName}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "firstName")}
              name={"firstName"}
              placeholder={"الاسم *"}
              containerStyle={"col-12"}
            ></TextInput>
          </div>
          <div className="col-lg-11 col-12 px-3 mt-4">
            <TextInput
              name={"email"}
              value={values.email}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "email")}
              type={"email"}
              placeholder={Lang.mail + "*"}
              style={{ direction: "ltr" }}
              containerStyle={"col-12"}
            ></TextInput>
          </div>
          {/* <TextInput
            type={"text"}
            value={values.lastName}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "lastName")}
            name={"lastName"}
            placeholder={Lang.lastName}
            containerStyle={"col-12  col-lg-5 mx-3 mt-4"}
          ></TextInput> */}
          <div className="d-flex flex-wrap col-12 px-lg-5">
            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"text"}
                value={values.UserName}
                onChange={handleChange}
                errorMessage={formikValidation(touched, errors, "UserName")}
                name={"UserName"}
                placeholder={"اسم المستخدم *"}
                containerStyle={"col-12"}
              ></TextInput>
            </div>

            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"password"}
                value={values.password}
                onChange={handleChange}
                errorMessage={formikValidation(touched, errors, "password")}
                name={"password"}
                placeholder={Lang.password + "*"}
                containerStyle={"col-12"}
                style={{ direction: "ltr" }}
              ></TextInput>
            </div>
          </div>
          {/* <DropDownList
            dataSource={dropdownLists?.titles}
            value={values.title}
            change={(e) => {
              setFieldValue("title", e.value);
            }}
            errorMessage={formikValidation(touched, errors, "title")}
            placeholder={Lang.jobTitle + "*"}
            iconName={"paperclip"}
            iconSize={16}
            containerStyle={"col-12 col-md-5 mx-3 mt-4"}
          ></DropDownList> */}
          {/* <DropDownList
            dataSource={dropdownLists.genders}
            value={values.gender}
            change={(e) => {
              setFieldValue("gender", e.value);
            }}
            errorMessage={formikValidation(touched, errors, "gender")}
            placeholder={Lang.gender + "*"}
            iconName={"paperclip"}
            iconSize={16}
            containerStyle={"col-12 col-md-5 mx-3 mt-4"}
          ></DropDownList> */}

          <div className="d-flex flex-wrap col-12 px-lg-5">
            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"text"}
                value={values.mobileNumber}
                onChange={handleChange}
                errorMessage={formikValidation(touched, errors, "mobileNumber")}
                name={"mobileNumber"}
                placeholder={Lang.phoneNumberOne}
                containerStyle={"col-12"}
              ></TextInput>
            </div>
            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"text"}
                value={values.OfficeNumber}
                onChange={handleChange}
                errorMessage={formikValidation(touched, errors, "OfficeNumber")}
                name={"OfficeNumber"}
                placeholder={Lang.officeNumber}
                containerStyle={"col-12"}
              ></TextInput>
            </div>
            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"text"}
                value={values.Address}
                onChange={handleChange}
                errorMessage={formikValidation(touched, errors, "Address")}
                name={"Address"}
                placeholder={Lang.Address}
                containerStyle={"col-12"}
              ></TextInput>
            </div>
            <div className="col-6 col-lg-6 d-flex mt-4 px-2 d-flex align-items-center ">
              <div className="mx-2"> تفعيل مستخدم</div>
              <Switch
                checked={values.active}
                name={"active"}
                onClick={() => {
                  setFieldValue("active", !!!values.active);
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap col-12 px-lg-5">
            <DropDownList
              dataSource={usersDropdownLists}
              value={values.ParentId}
              change={(e) => {
                setFieldValue("ParentId", e.value);
              }}
              errorMessage={formikValidation(touched, errors, "ParentId")}
              placeholder={Lang.ParentId}
              iconName={"paperclip"}
              iconSize={16}
              name={"ParentId"}
              containerStyle={"col-12 col-lg-6 px-3 mt-4"}
            ></DropDownList>
            <div className="col-12 col-lg-6 px-3 mt-4">
              <TextInput
                type={"text"}
                value={values.PersonInContactId}
                onChange={handleChange}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "PersonInContactId",
                )}
                name={"PersonInContactId"}
                placeholder={Lang.PersonInContact}
                containerStyle={"col-12"}
              ></TextInput>
            </div>
            {/* <DropDownList
              dataSource={usersDropdownLists}
              value={values.PersonInContactId}
              change={(e) => {
                setFieldValue("PersonInContactId", e.value);
              }}
              errorMessage={formikValidation(
                touched,
                errors,
                "PersonInContactId"
              )}
              placeholder={Lang.PersonInContact}
              name={"PersonInContactId"}
              iconName={"paperclip"}
              iconSize={16}
              containerStyle={"col-12 col-lg-6 px-3 mt-4"}
            ></DropDownList> */}
          </div>

          {/* <div className="col-12 col-md-5 mx-3 mt-4">
            <DateInput
              value={values?.brithDay}
              errorMessage={formikValidation(touched, errors, "brithDay")}
              name={"brithDay"}
              onChange={(e) => {
                setFieldValue("brithDay", e);
              }}
            />
          </div> */}

          {/* <div className={"d-flex flex-column  my-4 col-md-11 col-12"}>
            <div
              className={`d-flex px-3  col-11 container mb-3 ${styleStart(
                "m",
                2
              )}`}
            >
              <p className="my-0">{Lang.proessionalAreaOfResearch}</p>
            </div>

            <div
              className={`d-flex flex-column col-11 container px-3 py-2  ${customStyle(
                "TitleCard"
              )}`}
              style={{
                height: "fit-content",
                maxHeight: 250,
              }}
            >
              <div className="d-flex mb-3"></div>

              <div className="d-flex flex-column scroll py-3">
                {dropdownLists?.researchAreas?.map((item, index) => {
                  let memberPhoto = `url("/assets/images/icons/research.png")`;
                  return (
                    <MemberListItem
                      key={index}
                      id={item.id}
                      photo={memberPhoto}
                      index={index}
                      name={item.name}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        const value = e.target.value;
                        if (checked) {
                          setFieldValue("researchAreas", [
                            ...values?.researchAreas,
                            parseInt(value),
                          ]);
                        } else {
                          setFieldValue(
                            "researchAreas",
                            values.researchAreas.filter(
                              (items) => parseInt(items) != parseInt(value)
                            )
                          );
                        }
                      }}
                      values={values?.researchAreas?.map((item) => item?.id)}
                      length={dropdownLists?.researchAreas?.length - index}
                      checked={true}
                      idChar={"B"}
                    />
                  );
                })}
              </div>
            </div>
          </div> */}

          <div
            className="d-flex flex-column mx-4 px-xl-4 mb-3 mt-5"
            style={{ width: "100%" }}
          >
            <FileUploader
              containerStyle={"col-12"}
              contentStyle={"col-12"}
              borderColor={"#C7C7C9"}
              placeholderLTRWidth={150}
              placeholderRTLWidth={115}
              fileIconColor={"#1a73e8"}
              fileValue={values.file}
              fileOnClick={(e) => {
                e.target.value = "";
                setFieldValue("file", e.target.value);
              }}
              FileOnChange={(e) => {
                setFieldValue("file", e.target.files[0]);
              }}
              uploadButtonOnChange={() => {
                if (values.file) {
                  if (
                    !files.find(
                      (item) =>
                        item.fileName === values.file.name.substr(0, 35),
                    )
                  ) {
                    const allFiles = [
                      ...files,
                      {
                        id: files.length + 1,
                        fileName: values.file.name.substr(0, 35),
                        file: values.file,
                      },
                    ];
                    setFieldValue("files", [...allFiles]);
                    setFiles([...allFiles]);
                    setFieldValue("file", "");
                    setFieldTouched("files", false);
                  } else {
                    setDuplicateAlert(true);
                    setTimeout(() => {
                      setDuplicateAlert(false);
                    }, 1000);
                  }
                }
              }}
            />
            <FilesList
              containerStyle={"col-12 justify-content-start"}
              contentStyle={"col-12"}
              Data={[...files]}
              setFiles={setFiles}
              setFilesInFormik={setFieldValue}
              setFilesTouched={setFieldTouched}
              propInFormik={"files"}
            />
          </div>

          <div className="d-flex col-12 col-md-10 justify-content-between flex-wrap my-3">
            <div className="col-12 fw-bold mt-4">ضبط الصلاحيات</div>
            <div className="d-flex col-12 mb-4 justify-content-between flex-wrap align-items-center">
              <div className="col-xl-3 col-md-6 col-12 d-flex mt-4 d-flex justify-content-center align-items-center">
                <div className="ms-2">المسئول الرئيسي للنظام</div>
                <Switch
                  checked={values.IsSuperAdmin}
                  name={"IsSuperAdmin"}
                  onClick={() => {
                    setFieldValue("IsSuperAdmin", !!!values.IsSuperAdmin);
                  }}
                />
              </div>
              {/* <div className="col-xl-3 col-md-6 col-12 d-flex mt-4 d-flex justify-content-center align-items-center">
                <div className="mx-2"> مدير النظام </div>
                <Switch
                  checked={values.IsAdmin}
                  name={"IsAdmin"}
                  onClick={() => {
                    setFieldValue("IsAdmin", !!!values.IsAdmin);
                  }}
                />
              </div> */}
              {/* <div className="col-xl-3 col-md-6 col-12 d-flex mt-4 d-flex justify-content-center align-items-center">
                <div className="mx-2">مدير الإجراءات</div>
                <Switch
                  checked={values.IsTaskAdmin}
                  name={"IsTaskAdmin"}
                  onClick={() => {
                    setFieldValue("IsTaskAdmin", !!!values.IsTaskAdmin);
                  }}
                />
              </div> */}
              <div className="col-xl-3 col-md-6 col-12 d-flex mt-4 d-flex justify-content-center align-items-center">
                <div className="mx-2">مشارك</div>
                <Switch
                  checked={values.IsMember}
                  name={"IsMember"}
                  onClick={() => {
                    setFieldValue("IsMember", !!!values.IsMember);
                  }}
                />
              </div>
            </div>
            {/* <div className="col-6 col-lg-5  mt-4  d-flex align-items-center ">
              <div className="mx-2">تفعيل عضوية</div>
              <Switch
                checked={values.activeMember}
                name={"activeMember"}
                onClick={() => {
                  setFieldValue("activeMember", !!!values.activeMember);
                }}
              />
            </div> */}
          </div>
          <Button
            containerStyle={"col-3 my-3 mx-2"}
            styleClass="solid"
            disable={disable}
            content={disable ? Lang.saving : Lang.save}
            buttonStyleType="solid"
            type="submit"
          />
          <Button
            containerStyle={"col-3 my-3 mx-2"}
            content={Lang.cancel}
            onClick={() => {
              fromCommunity
                ? setModalVisible(false)
                : setModalVisible({
                    ...modalVisible,
                    ediUser: false,
                    helperData: null,
                    addUserData: false,
                  });
            }}
          />
        </div>
      </form>
    </>
  );
};

export default AddUserForm;
